import { SyncDirection } from "./types"

export const SYNC_DIR_FORWARD: SyncDirection = "forward" as const
export const SYNC_DIR_BACKWARD: SyncDirection = "backward" as const

export const PATH_PUBLISHED_EVENT = "pathPublished"
